import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { PerioExamCarouselOrbComponent } from '../perio-exam-carousel-orb/perio-exam-carousel-orb.component';
import { PerioExamTraversalStrategy } from '../../../perio-exam-screen/services/perio-exam/models';

export enum PerioExamDirectionSlots {
  'First' = 18,
  'Second' = 37,
  'Third' = 68,
  'Fourth' = 89,
}

export interface PerioExamDirectionItem {
  slot: PerioExamDirectionSlots;
  label: string;
  side: 'left' | 'right';
}

export interface PerioExamDirection {
  id?: PerioExamTraversalStrategy;
  items: PerioExamDirectionItem[];
  available: boolean;
}

@Component({
  selector: 'lib-perio-exam-direction-card',
  imports: [CommonModule, NgOptimizedImage, PerioExamCarouselOrbComponent, SvgIconComponent, TranslatePipe],
  templateUrl: './perio-exam-direction-card.component.html',
  styleUrl: './perio-exam-direction-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamDirectionCardComponent {
  public readonly selected = input(false);
  public readonly available = input(true);
  public readonly perioExamDirection = input.required<PerioExamDirection>();

  protected activeAndAvailable = computed(() => this.selected() && this.available());
  protected deselected = computed(() => !this.selected() && this.available());
  protected classList = computed(() => ({
    'border-background-green bg-background-green/10': this.activeAndAvailable(),
    'border-background-light-blue bg-background-light-blue': this.deselected(),
    'border-background-disabled bg-background-disabled opacity-60': !this.available(),
    'cursor-pointer': this.available(),
  }));

  protected cardClick = output<PerioExamDirection>();

  protected onCardClick(): void {
    if (this.available()) {
      this.cardClick.emit(this.perioExamDirection());
    }
  }
}
